"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "PriceMatrix", {
  enumerable: true,
  get: function get() {
    return _PriceMatrix.PriceMatrix;
  }
});
var _PriceMatrix = require("./PriceMatrix");